<template>
  <div id="manifest-import-integration">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="d-flex px-5 justify-space-between align-center">
        <h1>Integração da importação dos manifestos</h1>
        <v-btn elevation="2" color="success" large @click="isOpenConfirmDialog = true"> Consultar Manifesto </v-btn>
      </div>

      <div class="mt15"></div>

      <manifest-import-filters :loadingGetAll="loading" @filterSearch="filterSearch" />
      <div class="table mt-10">
        <v-data-table
          :headers="headers"
          :items="getManifest"
          :loading="loading"
          :items-per-page="paginate.pageSize"
          @update:items-per-page="changeItemsPerPage"
          no-data-text="Nenhum manifesto encontrado"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 50],
            itemsPerPageText: 'Itens por página'
          }"
        >
          <template v-slot:[`item.disabled`]="{ item, index }">
            <v-switch
              v-model="item.disabled"
              :false-value="true"
              :true-value="false"
              inset
              color="success"
              readonly
              @click.stop.prevent="openDialogStatus(item, index)"
            ></v-switch>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ transformImportDate(item.createdAt) }}
          </template>
          <template v-slot:[`item.sequenceCodesIntegration`]="{ item }">
            <copy-to-clipboard-tooltip
              v-if="item.sequenceCodesIntegration != null && item.sequenceCodesIntegration"
              :text="item.sequenceCodesIntegration.toString()"
            />

            <span v-else>-</span>
          </template>
          <template v-slot:[`item.sequenceCodesImported`]="{ item }">
            <copy-to-clipboard-tooltip
              v-if="item.sequenceCodesImported != null && item.sequenceCodesImported"
              :text="item.sequenceCodesImported.toString()"
            />

            <span v-else>-</span>
          </template>
          <template v-slot:[`item.sequenceCodesWithErrors`]="{ item }">
            <copy-to-clipboard-tooltip
              v-if="item.sequenceCodesWithErrors != null && item.sequenceCodesWithErrors"
              :text="item.sequenceCodesWithErrors.toString()"
            />

            <span v-else>-</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" v-if="isDetailsValid(item.status)">
              <router-link :to="`/imports/manifest-import-preview/${item.id}/details`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <ViewSVG v-bind="attrs" v-on="on" />
                  </template>
                  <span>Detalhes</span>
                </v-tooltip>
              </router-link>
            </div>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
      </div>
    </v-card>

    <div class="mt15"></div>

    <div class="mt60"></div>
    <manifest-dialog
      :isOpen.sync="isOpenConfirmDialog"
      :is-confirm-btn-loading="isConfirmLoading"
      :isConfirmBtnLoading="loadingIntegration"
      title="Confirmar consulta do manifesto"
      @confirmClick="fetchNewManifestImport"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>
<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import MessagesError from '../../../components/MessagesError.vue';
import ManifestDialog from '@/components/ManifestImport/ManifestDialog.vue';
import ManifestImportFilters from '@/components/ManifestImport/ManifestImportFilters.vue';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';

// SVGs
import ViewSVG from '../../../assets/img/view.svg';

export default {
  name: 'ManifestImportIntegration',
  components: {
    BreadCrumb,
    ViewSVG,
    MessagesError,
    ManifestDialog,
    ManifestImportFilters,
    CopyToClipboardTooltip
  },
  data: () => ({
    loading: false,
    loadingIntegration: false,
    isConfirmLoading: false,
    isOpen: false,
    isOpenConfirmDialog: false,
    menu: false,
    menu2: false,
    initialImportDate: null,
    endImportDate: null,
    responsibleSelected: null,
    statusSelected: null,
    users: [],
    statusShipment: [],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Manifestos',
        disabled: true,
        to: '/shipments',
        exact: true
      }
    ],
    headers: [
      { text: 'IMPORTADO POR', value: 'responsibleUserName' },
      { text: 'DATA', value: 'createdAt' },
      { text: 'MDF-ES CONSULTADOS', value: 'sequenceCodesIntegration' },
      { text: 'MDF-ES IMPORTADOS', value: 'sequenceCodesImported' },
      { text: 'MDF-ES COM ERROS', value: 'sequenceCodesWithErrors' },
      { text: 'STATUS', value: 'status' },
      { text: 'AÇÕES', value: 'actions' }
    ],

    errors: [],
    error500: null,
    errorsType: 'error',
    itemImportStatusProcessing: false,
    itemImportStatusError: false,
    idManifestSelected: null
  }),

  computed: {
    ...mapState('ManifestStore', ['paginate']),
    ...mapGetters('ManifestStore', ['getManifest']),

    formattedDateInitial() {
      if (!this.initialImportDate) return '';
      const [year, month, day] = this.initialImportDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedDateEnd() {
      if (!this.endImportDate) return '';
      const [year, month, day] = this.endImportDate.split('-');
      return `${day}/${month}/${year}`;
    },

    hasFilters() {
      if (this.initialImportDate || this.endImportDate || this.responsibleSelected || this.statusSelected) {
        return true;
      }
      return false;
    },

    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllManifest();
      }
    }
  },
  mounted() {
    this.fetchAllManifest();
    this.fetchAllUsers();
    this.handleAlert();
  },
  methods: {
    ...mapMutations('ManifestStore', ['setItemPerPage', 'setPageNumber']),
    ...mapActions('UserStore', ['fetchListUsers']),
    ...mapActions('ManifestStore', ['fetchManifest', 'fetchNewManifest']),

    handleAlert() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },

    async fetchAllManifest() {
      this.loading = true;
      try {
        await this.fetchManifest();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async fetchNewManifestImport(data) {
      this.loadingIntegration = true;
      try {
        const response = await this.fetchNewManifest(data);
        this.handleFeedback(response);
        this.fetchAllManifest();
      } catch (err) {
        console.error(err);
        this.handleFeedback({ success: false, errors: ['Falha ao buscar novos manifestos.'] });
      } finally {
        this.loadingIntegration = false;
        this.isOpenConfirmDialog = false;
      }
    },

    handleFeedback(response) {
      if (response.success) {
        this.errorsType = 'success';
        this.errors = ['Integração realizada com sucesso!'];
      } else {
        this.errorsType = 'error';
        this.errors = response.errors || ['Ocorreu um erro desconhecido.'];
      }
    },

    async fetchAllUsers() {
      try {
        const data = await this.fetchListUsers();
        this.users = data;
      } catch (err) {
        console.error(err);
      }
    },

    openDialogStatus(item, index) {
      this.dialogStatus = true;
      this.statusItem = {
        ...item,
        index
      };
    },

    isDetailsValid(status) {
      const invalidStatuses = [
        'Descartada',
        'Processando',
        'Consultando TMS',
        'Falha ao Consultar TMS',
        'Consulta sem resultados'
      ];
      return !invalidStatuses.includes(status);
    },
    filterSearch() {
      this.setPageNumber(1);
      this.fetchAllManifest();
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);
      this.fetchAllManifest();
    },

    transformImportDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    }
  }
};
</script>
